const getFontFace = (url, name, fileName) => (
    `@font-face {
        font-family: "${name}";
        src: url("${url}/${fileName}.eot");
        src: url("${url}/${fileName}.eot?#iefix") format("embedded-opentype"), 
        url("${url}/${fileName}.woff") format("woff"), 
        url("${url}/${fileName}.ttf") format("truetype"), 
        url("${url}/${fileName}.svg#name") format("svg");
        font-weight: normal;
        font-style: normal;
    }
    `
)

const getFontFacesStyles = (cinemaUrl, fonts) => {
    let fontFaceCss = ''

    fonts.map(({name, fileName, path}) => {
        const url = cinemaUrl + path
        fontFaceCss = fontFaceCss + getFontFace(url, name, fileName)
    })

    return fontFaceCss
}

export default getFontFacesStyles